module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/payment-receipt-approval/payment-receipt-app-form/payment-receipt-app-form.component.css
// module id = ./src/app/recovery/payment-receipt-approval/payment-receipt-app-form/payment-receipt-app-form.component.css
// module chunks = main